import CategoryCollectionPage from './CategoryCollectionPage';
import { KOSZE_CONFIG } from './categoryPageConfigs';
export default function KoszeKwiatowePage() {
  return <CategoryCollectionPage config={KOSZE_CONFIG} />;
}
